export enum SalaryDividendAlgorithmEnum {
  Precise = 'PRECISE',
  Approximation = 'APPROXIMATION',
}